import * as React from "react";
import cx from "classnames";
import { useMediaQuery } from "@react-hookz/web";

type Props = {
	children?: React.ReactNode;
};

export const GradientCoverContainer: React.FC<Props> = ({ children }) => {
	// workaround: DmmHeader height
	// DmmHeader #L6
	const isMobile = !useMediaQuery("(min-width: 1024px)");
	return (
		<div className={cx("lg:relative mt-[55px]", { "mt-[40px]": isMobile })}>
			{children}
			<div className="hidden lg:block absolute inset-0 bg-[url(/images/gradient-cover.png)] bg-[length:100%_auto] bg-repeat-y pointer-events-none" />
		</div>
	);
};
